import React, { createContext, useContext } from 'react';
import { rootStore } from '../stores/RootStore.js';

const StoreContext = createContext(rootStore);

export const StoreProvider = ({ children }) => <StoreContext.Provider value={rootStore}>{children}</StoreContext.Provider>;

export const useStore = () => useContext(StoreContext);

